import { render, staticRenderFns } from "./person-hour.vue?vue&type=template&id=5e9f9d20"
import script from "./person-hour.vue?vue&type=script&lang=js"
export * from "./person-hour.vue?vue&type=script&lang=js"
import style0 from "./person-hour.vue?vue&type=style&index=0&id=5e9f9d20&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports